
const FeedbackType = {
    Forbidden : 'Forbidden',
    Confirm : 'Confirm',
    PwdAuth: 'PwdAuth',
    OtherAuth: 'OtherAuth'
}

const dataSource = [{
    name: '手机',
    quantity: 1.00,
    price: 2100.00,
    total: 101.70
  }, {
    name: '黄瓜',
    quantity: 10.00,
    price: 2.00,
    total: 23.80
  }, {
    name: '毛巾',
    quantity: 3.00,
    price: 15.00,
    total: 3.90
  }];
  
  const columns = [{
    dataIndex: 'name',
    title: '商品名称',
    readOnly: true,
    controlType: "TextBox",
    precision: 0,
  }, {
    dataIndex: 'quantity',
    title: '数量',
    readOnly: false,
    controlType: "NumTextBox",
    precision: 2
  }, {
    dataIndex: 'price',
    title: '零售单价',
    readOnly: false,
    controlType: "NumTextBox",
    precision: 2,
  }, {
    dataIndex: 'total',
    title: '总计',
    readOnly: true,
    controlType: "NumTextBox",
    precision: 2,
  }];

export  {FeedbackType,dataSource,columns}